module.exports = "<span></span>\n<span></span>\n<span></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/components/actions-btn/actions-btn.html
// module id = 302
// module chunks = 0